<section class="content">
  <div class="container-fluid">

    <form class="register-form1" [formGroup]="formGroupPageName"  (ngSubmit)="onSubmit()" >
      <app-breadcrumb-button-top [titlePage]="title" [showBtnStatus]="false"
      [showBtnAddNew]="true" [showBtnCancel]="true" [showBtnSaveChanges]="true"
      [addOrEditButton]="addOrEditButton" [formGroupPageName]="this.formGroupPageName"
      (eventOnAddEmitter)="onNew()" (eventOnCloseEmitter)="onClose()"></app-breadcrumb-button-top>

      <p-messages [(value)]="message"></p-messages>
      <input formControlName="appLogo" [(ngModel)]="objDeviceApp.appLogo" type="hidden" />
      <input formControlName="extention" [(ngModel)]="objDeviceApp.extention" type="hidden" />

      <div class="card" style="padding: 10px 10px;">
        <div class="row">
          <div class="col-xl-2 col-lg-2 col-md-10 col-sm-10 tc">
            <img name="imgPreview" id="imgPreview" asp-for="Image" (click)="triggerFileInput()" [src]="bannerOrNoImagePathUrl"
                class="rounded img-thumbnail" alt=""
                style="cursor: pointer; max-height: 150px; max-width: 150px;"
                pTooltip="Click to change image (format: {{enumExtensionFile.Extention_ImageFile}})"
                tooltipPosition="bottom">
            <input  #vcFileBannerSelected type="file" [accept]="enumExtensionFile.Extention_ImageFile"
                  pTooltip="Click to change image (format: {{enumExtensionFile.Extention_ImageFile}})" tooltipPosition="bottom"
                  class="photosup_input_file rounded img-thumbnail" style="display: none;"
                  data-preview="imgPreview" (change)="onChangeFileUpload($event)" />
          </div>

          <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12">
            <div class="row">

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.appName}}</mat-label>
                  <input matInput formControlName="appName" [(ngModel)]="objDeviceApp.appName" placeholder="{{textField.appName}}" />
                  <app-validator-error [control]="formGroupPageName.get('appName')" ></app-validator-error>
                </mat-form-field>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.packageName}}</mat-label>
                  <input matInput formControlName="packageName" [(ngModel)]="objDeviceApp.packageName" placeholder="{{textField.packageName}}"
                  (change)="onChangePackageName()" (keyup)="onChangePackageName()"  />
                  <app-validator-error [control]="formGroupPageName.get('packageName')" ></app-validator-error>
                </mat-form-field>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.applicationId}}</mat-label>
                  <input matInput formControlName="applicationId" [(ngModel)]="objDeviceApp.applicationId" placeholder="{{textField.applicationId}}" />
                  <app-validator-error [control]="formGroupPageName.get('applicationId')" ></app-validator-error>
                </mat-form-field>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.versionName}}</mat-label>
                  <input matInput formControlName="versionName" [(ngModel)]="objDeviceApp.versionName" placeholder="{{textField.versionName}}" />
                  <app-validator-error [control]="formGroupPageName.get('versionName')" ></app-validator-error>
                </mat-form-field>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.versionCode}}</mat-label>
                  <input matInput formControlName="versionCode" [(ngModel)]="objDeviceApp.versionCode" placeholder="{{textField.versionCode}}" />
                  <app-validator-error [control]="formGroupPageName.get('versionCode')" ></app-validator-error>
                </mat-form-field>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.buildNumber}}</mat-label>
                  <input matInput formControlName="buildNumber" [(ngModel)]="objDeviceApp.buildNumber" placeholder="{{textField.buildNumber}}" />
                  <app-validator-error [control]="formGroupPageName.get('buildNumber')" ></app-validator-error>
                </mat-form-field>
              </div>

            </div>
          </div>

          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="row">

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.linkAndroid}}</mat-label>
                  <input matInput formControlName="linkAndroid" [(ngModel)]="objDeviceApp.linkAndroid" placeholder="{{textField.linkAndroid}}" />
                  <app-validator-error [control]="formGroupPageName.get('linkAndroid')" ></app-validator-error>
                </mat-form-field>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.linkApple}}</mat-label>
                  <input matInput formControlName="linkApple" [(ngModel)]="objDeviceApp.linkApple" placeholder="{{textField.linkApple}}" />
                  <app-validator-error [control]="formGroupPageName.get('linkApple')" ></app-validator-error>
                </mat-form-field>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.linkWebSite}}</mat-label>
                  <input matInput formControlName="linkWebSite" [(ngModel)]="objDeviceApp.linkWebSite" placeholder="{{textField.linkWebSite}}" />
                  <app-validator-error [control]="formGroupPageName.get('linkWebSite')" ></app-validator-error>
                </mat-form-field>
              </div>

            </div>
          </div>

          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="tr">
                  <span class="tr badge badgeStatus bg-green">
                    <label for="isRequired">
                    <input type="checkbox" [checked]="objDeviceApp.isRequired" [(ngModel)]="objDeviceApp.isRequired"
                      formControlName="isRequired">{{textField.isRequired}}(Y/N)</label>
                  </span>

                </div>

                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>{{textField.versionInfo}}</mat-label>
                  <textarea matInput formControlName="versionInfo" [(ngModel)]="objDeviceApp.versionInfo" placeholder="{{textField.versionInfo}}" style="height:400px;"></textarea>
                  <app-validator-error [control]="formGroupPageName.get('versionInfo')" ></app-validator-error>
                </mat-form-field>
              </div>
            </div>
          </div>

        </div>
      </div>

      <app-tools-button-save [showBtnCancel]="true" [addOrEditButton]="addOrEditButton" [formGroupPageName]="this.formGroupPageName"
      (eventOnCloseEmitter)="onClose()"></app-tools-button-save>

    </form>

  </div>
</section>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-toast position="top-center"></p-toast>
